var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-actions',{attrs:{"has-default":"","slim-size":"","actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }